<div class="spinner-container">
  <div class="spinner">
    &nbsp;
  </div>
</div>
